import React, { useState } from "react";
import Button from "../../../components/ui/Button/Button";
import { Dropdown } from "../../../components/ui/Dropdown/Dropdown";
import InputDate from "../../../components/ui/InputDate/InputDate";

const checkByOptions = [
  {
    id: "",
    name: "전체",
  },
  {
    id: "true",
    name: "즉시 발송",
  },
  {
    id: "false",
    name: "예약 발송",
  },
];

function Filter(props) {
  const { onFilter, onSubmitFilter, onResetFilter, filter, setImmediate } =
    props;
  const [discountStartDate, setDiscountStartDate] = useState(null);
  const [discountEndDate, setDiscountEndDate] = useState(null);

  const onChangeDiscountStartDate = (value) => {
    setDiscountStartDate(value);
    onFilter({
      from: value?.unix(),
    });
  };

  const onChangeDiscountEndDate = (value) => {
    setDiscountEndDate(value);
    onFilter({
      to: value?.unix(),
    });
  };

  return (
    <div className="my-3 bg-input-grey rounded-sm">
      <div className="flex items-center px-5 pt-3 pb-1">
        <span className="w-[92px] font-bold">발송 상태</span>
        <div className="flex w-full justify-between">
          <div className="flex items-center">
            <div className="flex mr-3 items-center">
              <input
                name="status"
                id="all"
                type="radio"
                className="accent-black mr-2"
                checked={filter?.status === ""}
                onChange={() => onFilter({ status: "" })}
              />
              <label htmlFor="all">전체</label>
            </div>
            <div className="flex mr-3 items-center">
              <input
                name="status"
                id="complete"
                type="radio"
                className="accent-black mr-2"
                onChange={() => onFilter({ status: "COMPLETED" })}
              />
              <label htmlFor="complete">발송 완료</label>
            </div>
            <div className="flex mr-3 items-center">
              <input
                name="status"
                id="waiting"
                type="radio"
                className="accent-black mr-2"
                onChange={() => onFilter({ status: "WAITING" })}
              />
              <label htmlFor="waiting">발송 예약 대기</label>
            </div>
            <div className="flex mr-3 items-center">
              <input
                name="status"
                id="cancel"
                type="radio"
                className="accent-black mr-2"
                onChange={(e) => onFilter({ status: "CANCELED" })}
              />
              <label htmlFor="cancel">발송취소 완료</label>
            </div>
          </div>
          <div className="-mr-4">
            <Button
              onClick={onSubmitFilter}
              borderColor="border border-secondary-grey"
              text="필터 검색"
              width="w-28"
            />
            <Button
              onClick={onResetFilter}
              borderColor="border border-secondary-grey"
              text="필터 초기화"
              width="w-28"
            />
          </div>
        </div>
      </div>

      <div className="flex items-center px-5 pb-5">
        <div className="flex items-center w-full">
          <div className="flex items-center w-[30%] mr-14">
            <span className="w-28 font-bold">검색</span>
            <input
              type="text"
              className="border p-2 rounded-[4px] w-full border-primary-grey"
              placeholder="제목 입력"
              onChange={(e) => onFilter({ title: e.target.value })}
              value={filter?.title}
            />
          </div>

          <div className="flex items-center gap-[5px] w-1/2">
            <span className="w-10 font-bold">기간</span>
            <div className="mr-2">
              <Dropdown
                placeholder="전체"
                textColor="text-black"
                dropdownWidth="w-32"
                backgroundDropdown="bg-white"
                positionDropdown={`top-10`}
                width="w-32"
                options={checkByOptions}
                onClickItem={(id) => setImmediate(id)}
              />
            </div>
            <InputDate
              value={discountStartDate}
              onChange={onChangeDiscountStartDate}
              defaultValue={discountStartDate}
            />
            <span className="text-secondary-grey">-</span>
            <InputDate
              value={discountEndDate}
              onChange={onChangeDiscountEndDate}
              defaultValue={discountEndDate}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Filter;
